
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/office/[url_slug]",
      function () {
        return require("private-next-pages/office/[url_slug]/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/office/[url_slug]"])
      });
    }
  